module.exports = __webpack_public_path__ + "img/cyan_heart_cute_face.b5cd3034.png";